import ReactDom from "react-dom";

interface Props {
  children: React.ReactNode;
}

const Portal = ({ children }: Props) => {
  const element = document.getElementById("modal") as HTMLElement;
  return ReactDom.createPortal(children, element);
};

export default Portal;
